export const FEED_VIEW_TYPES = {
  DEFAULT: "default",
  COMPACT: "short",
};
